// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"wI-z","mainContent":"xI-z","activeSidebar":"yI-z"};